export const OTP_Title = {
  telefono:
    'El código de verificación le llegará a tu cliente por WhatsApp, pídele que te lo comparta.',
  correo:
    'El código de verificación podría llegarle a la carpeta de correos no deseados (spam), pídele que revise todas las bandejas.',
};

export const OTP_PROVIDER = {
  telefono: 'Código enviado al número:',
  correo: 'Código enviado al correo:',
};
